export default function getSafe(fn, default_val=undefined) {
    try {
        return fn();
    } catch (e) {
        return default_val;
    }
}
